
<h2 mat-dialog-title>Conferma</h2>
  <mat-dialog-content>
    <p>Confermi la creazione del preventivo?</p>
    <!-- <p>Conferma che le informazioni inserite sono veritiere e accetta i Termini e Condizioni:</p>
    <mat-checkbox [(ngModel)]="confirmed">Confermo quanto riportato e accetto</mat-checkbox> -->
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Indietro</button>
    <button mat-raised-button color="primary" (click)="confirm()">
      <mat-icon>check</mat-icon>
        Confermo
      </button>
  </mat-dialog-actions>